import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
 
import { Alert, Snackbar } from '@mui/material';
import { Col, Tooltip } from 'antd';
import Loading from "components/Loading";
import { get } from 'lodash';
import { handleGetClass } from "store/classes/thunks";
import { useCurrentUser } from 'store/users/selectors';
import styled from 'styled-components';
import { makeStyles } from 'utils/styles/mui';
import {
    IMG_7574,
    IMG_7575,
    IMG_7576,
    IMG_7577,
    IMG_7595,
    IMG_7596,
    IMG_7600,
    IMG_7605,
    IMG_7611,
    IMG_7614
} from 'utils/assets/images';
//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------







const THEME = [
    'linear-gradient(90deg, #5270fc, #5270fc 100%, #ffffff)',
    'linear-gradient(90deg, #fc9e19, #fc9e19 100%, #ffffff)',
    'linear-gradient(90deg, #002d75, #002d75 100%, #ffffff)',
    'linear-gradient(90deg, #00bdab, #00bdab 100%, #ffffff)',
    'linear-gradient(90deg, #7c2ae8, #7c2ae8 100%, #ffffff)',
    'linear-gradient(90deg, #05c1c9, #05c1c9 100%, #ffffff)'
]
const AVATARS = {
    IMG_7614,
    IMG_7611,
    IMG_7605,
    IMG_7600,
    IMG_7574,
    IMG_7575,
    IMG_7576,
    IMG_7577,
    IMG_7595,
    IMG_7596
}
const dummyPicture = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FdummyPicture.png?alt=media&token=1354d5b3-b159-401e-aac8-122e76009c06`

const UserModal = styled.div`
left: 50%;
max-width: 85vw;
position: absolute;
top: 50%;
transform: translate(-50%, -50%);
width: 100%;
@media screen and (max-width: 768px){
    max-width: 95vw;
}
`;
const UserPopUpArea = styled.div`
background-color: rgb(82,84,82);
border-radius: 10px;
padding: 28px;
position:relative;
display: flex;
flex-direction: column;
@media screen and (max-width: 768px){
    padding: 15px;
}
`;
const CloseBtn = styled.div`
border: none;
cursor: pointer;
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
width: 30px;
height: 30px;
border-radius: 50%;
position: absolute;
top: 0px;
right: 0px;
color: white;
z-index: 1;
`;
const UserArea = styled.div`
display:flex;
flex-direction:column;
overflow:auto;
overflow-x:auto;
width: 100%;
display:flex;
flex-wrap: wrap;
flex-direction:row;
align-items: center;
justify-content: center;
`;
const Wrapper = styled.div`
cursor: pointer;
border: ${p => p.active ? ` 2px solid green` : 'none'};
padding: 4px;
flex-direction: row;
padding: 2px;
border-radius: 50%;
margin:${p => p.active ? ` 18px` : '20px'};
justify-content: center;
align-items: center;
display: flex;
flex-direction: row;
position:relative;
@media screen and (max-width: 768px){
    margin:${p => p.active ? ` 4px` : '6px'};
}
`;
const Logo = styled.img`
height: auto;
width: 100px;
`;
const LogoBottomRow = styled.div`
display: flex;
flex-direction: row;
justify-content: flex-end;
width:100%;
`;
const LoaderWrapper = styled.div`
position:absolute;
z-index:100;
`;
const ImageRow = styled.div`
display: flex;
flex-wrap: wrap;
align-items: center;
justify-content: center;
`;
const ColorCircle = styled.li`
   background:${p => p.bgColor ? p.bgColor : THEME[0]};
   cursor: pointer;
`;
const CardItem = styled.div`
background:${p => p.bgColor ? p.bgColor : THEME[0]};
`;
const NoteText = styled.span`
    margin-left: 10px;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
`;
const useStyles = makeStyles((theme) => ({
    titleText: {
        fontWeight: 400,
        color: 'rgb(255, 255, 255)',
        fontSize: 20,
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 17
    }
}));

export default function ClassCard({ classInfo, fromDrawer = false, }) {
    const [editTitle, setEditTitle] = React.useState(false);
    const [displayName, setDisplayName] = useState('')
    const [avatarSelected, setAvatarSelected] = useState(null)
    const [classLoader, setClassLoader] = useState(false)
    const [displaynameUpdate, setdisplaynameUpdate] = useState(false)
    const [theme, setTheme] = useState('')
    const [notes, setNotes] = useState('')
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const currentUser = useCurrentUser()
    const [openAlert, setOpenAlert] = React.useState({ open: false, message: "" });

    useEffect(() => {
        setDisplayName(get(classInfo, "displayName", ''))
        setNotes(get(classInfo, "config.notes", ''))
        setAvatarSelected(get(classInfo, "config.avatar", ''))
        setTheme(get(classInfo, "config.theme", ''))
    }, [classInfo])

    const combinedClassCode = `${get(classInfo, "displayName", '')} (${get(classInfo, "code", '')})`;
    const totalNameCode = combinedClassCode.length > 40 ? combinedClassCode.slice(0, 40) + '...' : combinedClassCode;

    const redirectToHome = async () => {
        const isArchived = get(classInfo,"archived",false); 
        if(isArchived){
            setOpenAlert({open:true,message:`Class has been archived by your teacher please contact your teacher`});
            return;
        }
        if (classLoader) return;
        setClassLoader(true)
        await dispatch(handleGetClass(classInfo.id));
        setClassLoader(false)
        navigate(`/student/class?view=home`);
    }
    const handleClose = () => {
        setOpenAlert({ open: false, message: '' })
    };
    return (
        <Col xs={24} sm={fromDrawer ? 24 : 12} md={fromDrawer ? 24 : 12} lg={fromDrawer ? 24 : 8} xl={fromDrawer ? 24 : 6}>
              <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={openAlert.open}
                autoHideDuration={3000}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    <strong>ALERT:</strong> {openAlert.message}
                </Alert>
            </Snackbar>
            <div className="userSection showClickIcon" onClick={redirectToHome}>
                <CardItem className="userHeader" bgColor={theme}>
                    <div className="userHeadEdit"></div>
                        <label> 
                            {displaynameUpdate && <Loading white size={15} />} 
                        <Tooltip className="breakTheSentence" title={combinedClassCode.length > 40 ? combinedClassCode : null}>
                            {/* {get(classInfo, "displayName", '')}  */}
                            {/* ({get(classInfo, "code", '')})  */}
                            {totalNameCode}
                            </Tooltip>
                            {classInfo.archived?"(Archived)":""}
                        </label>
                    <div className="userHeadPic">
                        <img src={AVATARS[avatarSelected] ? AVATARS[avatarSelected] : dummyPicture } />
                    </div>
                </CardItem>
                <div className="noteSelf">
                    <div className="noteSelfInr">
                        <div className="noteSelfLeft 333">
                            <Button>Notes:</Button>
                            <NoteText className='noteTxtAply'>{notes}</NoteText>
                        </div>
                    </div>
                   
                
                    <div className="noteLinks">
                        <ul>
                            <li><a> {classLoader ? (<LoaderWrapper> <Loading size={25} /> </LoaderWrapper>) : null} Home</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </Col>
    )
}